var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarMascot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 199,
    viewBox: "0 0 189 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star Mascot"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2401",
    filter: "url(#filter0_f_912_21983)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.9539,
    cy: 99.5149,
    rx: 54.035,
    ry: 59.4694,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.489 99.5149C148.489 132.129 124.476 158.484 94.9539 158.484C65.4314 158.484 41.4189 132.129 41.4189 99.5149C41.4189 66.9008 65.4314 40.5455 94.9539 40.5455C124.476 40.5455 148.489 66.9008 148.489 99.5149Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.194 59.893C145.227 57.7238 133.283 71.0358 129.126 73.8612C129.127 73.8626 129.13 73.8691 129.135 73.8806C129.466 74.6265 139.005 96.4091 142.092 107.085C142.143 107.262 142.193 107.436 142.24 107.606C150.098 86.7486 156.47 71.6779 155.973 67.2447C155.973 62.8337 152.801 60.4771 151.194 59.893Z",
    fill: "#FFFF38"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0982 141.047C88.353 140.976 87.5456 140.9 86.6408 140.822C84.2616 148.495 76.2087 163.839 63.0259 163.839C57.3692 163.839 51.7963 161.847 48.2827 157.829C42.0844 151.989 40.6668 139.643 42.6363 125.014C50.1707 124.908 55.4872 119.568 59.7276 105.179L55.3776 83.7009C56.9348 79.9854 57.9869 77.4649 58.3883 76.5024C58.5099 76.2109 58.6398 75.9249 58.7794 75.6416L59.4136 74.3547C67.0393 59.1195 76.3958 45.8182 85.9172 38.517C90.7495 35.4778 98.0908 34.8584 102.863 38.517C112.285 45.7424 121.552 58.8439 129.135 73.8806C129.466 74.6265 139.005 96.4091 142.092 107.085L142.24 107.606C148.336 129.495 149.11 149.72 140.504 157.829C136.99 161.847 131.417 163.839 125.76 163.839C112.577 163.839 104.524 148.493 102.145 140.82C95.5392 141.658 93.3143 141.447 89.0982 141.047Z",
    fill: "#FFFF38"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0774 97.5166L53.4755 88.3085C54.1411 86.6668 54.7843 85.1166 55.3776 83.7009L59.7276 105.179C54.8874 117.604 49.7117 123.085 43.1357 123.118C43.9149 117.861 45.117 112.334 46.6794 106.725L50.0774 97.5166Z",
    fill: "#FFFF38"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0767 117.776C36.8032 121.93 40.6668 123.13 43.1357 123.118C43.9149 117.861 45.117 112.334 46.6794 106.725L50.0774 97.5166L53.4755 88.3085C54.1411 86.6668 54.7843 85.1166 55.3776 83.7009C41.8276 90.4787 35.8071 109.541 36.0767 117.776Z",
    fill: "#FFFF38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.081 119.888C36.9811 122.439 38.4963 124.002 40.8275 124.76C41.4099 124.95 42.0239 125.023 42.6363 125.014C42.7007 124.535 43.064 123.601 43.1357 123.118C40.6668 123.13 36.8032 121.93 36.0767 117.776C36.0952 118.342 35.8925 119.354 36.081 119.888Z",
    fill: "#ACAC22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6363 125.014C50.1707 124.908 55.4872 119.568 59.7276 105.179C54.8874 117.604 49.7117 123.085 43.1357 123.118C43.064 123.601 42.7007 124.535 42.6363 125.014Z",
    fill: "#ACAC22"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 77",
    d: "M139.066 98.5765L136.02 90.5194C135.297 88.7807 137.426 93.085 136.739 91.5421C139.312 96.3207 142.987 101.467 143.723 103.672L142.252 107.716L139.066 98.5765Z",
    fill: "#ACAC22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 75",
    d: "M90.1748 89.475C91.2441 90.6961 94.5056 92.4057 98.9968 89.475",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 76",
    d: "M90.9102 74.0278H98.2619",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2397",
    cx: 109.29,
    cy: 74.2288,
    r: 3.14619,
    fill: "black",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2398",
    cx: 79.8825,
    cy: 74.2288,
    r: 3.14619,
    fill: "black",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2402",
    cx: 1.83792,
    cy: 1.83792,
    r: 1.83792,
    transform: "matrix(1 0 0 -1 108.554 74.2288)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2403",
    cx: 1.83792,
    cy: 1.83792,
    r: 1.83792,
    transform: "matrix(1 0 0 -1 79.1475 74.2288)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 2396",
    d: "M90.3418 73.126C90.3418 82.6167 82.4466 90.3729 72.6294 90.3729C62.8122 90.3729 54.917 82.6167 54.917 73.126C54.917 63.6354 62.8122 55.8792 72.6294 55.8792C82.4466 55.8792 90.3418 63.6354 90.3418 73.126ZM134.256 73.126C134.256 82.6167 126.361 90.3729 116.544 90.3729C106.726 90.3729 98.8311 82.6167 98.8311 73.126C98.8311 63.6354 106.726 55.8792 116.544 55.8792C126.361 55.8792 134.256 63.6354 134.256 73.126Z",
    fill: "#D9D9D9",
    fillOpacity: 0.25,
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 60_2",
    d: "M79.8613 140.144C79.8613 140.144 83.0556 140.469 86.9134 140.821C86.6624 141.616 86.368 142.494 85.9948 143.427L79.8613 140.144Z",
    fill: "#ACAC22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 61",
    d: "M108.708 140.144C108.708 140.144 105.514 140.469 101.656 140.821C101.907 141.616 102.201 142.494 102.575 143.427L108.708 140.144Z",
    fill: "#ACAC22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_912_21983",
    x: 0.918945,
    y: 0.0454712,
    width: 188.07,
    height: 198.939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_912_21983"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarMascot);
export default __webpack_public_path__ + "static/media/Star Mascot.d8dd15684146ec563f1107c7b808ceae.svg";
export { ForwardRef as ReactComponent };